'use client';

import { UpsellData } from '@wwe-portal/web/services/payment/type';
import { useXsollaPayment } from '@wwe-portal/web/hooks/payment/use-xsolla-payment';

import { DIALOG_ID_UPSELL_OFFER } from '@wwe-portal/web/utils/constants/query-key';

import {
  InterstitialOfferDialog,
  InterstitialOfferDialogV2Props,
} from './offer-dialog';
import {
  registerDialog,
  removeDialog,
  showDialogById,
} from '@wwe-portal/ui/components/dialog/portable-dialog';
import { sendOfferPurchaseEvent } from '../../libs/analytics/offer';

registerDialog(DIALOG_ID_UPSELL_OFFER, InterstitialOfferDialog);
export const showUpsellDialog = (props: InterstitialOfferDialogV2Props) => {
  showDialogById(DIALOG_ID_UPSELL_OFFER, props as never);
};

export const closeUpsellDialog = () => {
  removeDialog(DIALOG_ID_UPSELL_OFFER);
};

interface UseUpsellOffer {
  storageKey: string;
}

export const useUpsellOffer = ({ storageKey }: UseUpsellOffer) => {
  const { startPayment } = useXsollaPayment(storageKey, {
    onPaymentSuccess: (data) => {
      closeUpsellDialog();

      sendOfferPurchaseEvent(data, {
        currencies: data.context.currencies,
        balance: data.context.balance,
        currentUser: data.context.currentUser,
        screenId: data.context.screenId,
      });
    },
  });

  const handleUpsell = (upsellData: UpsellData) => {
    if (!upsellData) return;

    showUpsellDialog({
      interstitialData: upsellData.intersititalData,
      onClose: () => {
        closeUpsellDialog();
      },
      offerId: upsellData.offerId,
      onStartPayment: (payload) => {
        const { offerData, context } = payload;
        startPayment({
          offerData,
          context: {
            ...context,
            screenId: upsellData.intersititalData.id,
          },
        });
      },
      dialogId: DIALOG_ID_UPSELL_OFFER,
    });
  };

  return {
    handleUpsell,
  };
};
